import React, { useState } from "react";
import { ParticipantInterface } from "../../interfaces/ParticipantInterface";
import { SeminarInterface, SeminarState } from "../../interfaces/SeminarInterface";
import { PaginatedListInterface } from "../../interfaces/PaginatedList";
import { API } from "../../services/api";

const Participant = ({ participant, seminar, onChange }: any) => {
  const [newParticipantEmail, setNewParticipantEmail] = useState<string>("");
  const [error, setError] = useState<string>();

  const handleChange = (event: any) => {
    const { value } = event.target;
    const pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    if (!value || pattern.test(value)) {
      setError(undefined);
    } else {
      setError("Bitte geben Sie eine gültige Email-Adresse ein!");
    }
    setNewParticipantEmail(event.target.value);
  };

  const createParticipant = async (email: string) => {
    try {
      await API.post(`host/seminars/${seminar.id}/participants`, {
        participantEmails: [email]
      });
    } catch (e) {
      if (e.statusCode === 400) setError("Bitte geben Sie eine gültige Email-Adresse ein");
    }

    await onChange();
  };

  const deleteParticipant = async (id: string) => {
    await API.delete(`host/seminars/${seminar.id}/participants/${id}`);
    await onChange();
  };

  if (participant)
    return (
      <div className="row" style={{ marginTop: "5px", backgroundColor: "#fff", padding: 10, borderRadius: 10 }}>
        <div className="col-4">{participant.email}</div>
        <div className="col-4">{participant.accessCode}</div>
        <div className="col-4" style={{ textAlign: "right" }}>
          <button
            type="button"
            onClick={async () => {
              await deleteParticipant(participant.id);
            }}
            className="btn btn-sm btn-danger"
          >
            Löschen
          </button>
        </div>
      </div>
    );

  return (
    <div>
      <div className="row" style={{ marginTop: "5px", display: "flex" }}>
        <div className="col-4">
          <label htmlFor="email">Neuen Teilnehmer einladen</label>
          <input className="form-control" type="email" placeholder="Email eingeben..." onChange={handleChange}
                 value={newParticipantEmail} />
        </div>
        <div className="col-4" style={{ alignSelf: "flex-end" }}>
          <button style={{ height: "37px" }} type="submit" onClick={() => createParticipant(newParticipantEmail)}
                  className="btn btn-sm btn-success">
            Einladen
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12">{error && <p style={{ color: "red", fontSize: "11pt" }}>{error}</p>}</div>
      </div>
    </div>
  );
};

interface ParticipantsProps {
  participants: PaginatedListInterface<ParticipantInterface>;
  seminar: SeminarInterface;
  onChange: () => void;
}

const Participants = (props: ParticipantsProps) => {

  const warning = props.seminar.state === SeminarState.COMPLETED ?
    "Sie können keine neuen Teilnehmer mehr einladen, da das Seminar bereits beendet wurde" :
    props.seminar.state === SeminarState.CREATED && !props.seminar.scheduledStart ?
      "Bitte legen Sie ein Startdatum fest, um Teilnehmer einzuladen" :
      undefined;

  if (warning) {
    return (
      <>
        <br />
        <div className="card bg-warning">
          <div className="card-body">{ warning }</div>
        </div>
      </>
    );
  }

  return (
    <div>
      <br />
      <br />
      <h4>Teilnehmer</h4>
      <div className="form-group">
        {props.participants && props.participants.items.length > 0 && (
          <div>
            <div className="row">
              <div className="col-4">
                <label htmlFor="email">Email</label>
              </div>
              <div className="col-4">
                <label htmlFor="accessCode">Zugangscode</label>
              </div>
            </div>
            <div
              style={{
                padding: 15,
                paddingTop: 0
              }}
            >
              {props.participants.items.map((participant) => {
                return <Participant key={participant.id} participant={participant} onChange={props.onChange}
                                    seminar={props.seminar} />;
              })}
            </div>
          </div>
        )}
        <Participant onChange={props.onChange} seminar={props.seminar} />
      </div>
    </div>
  );
};

export default Participants;
